'use strict';

export default class ForgotPasswordController {
  user = {
    email: ''
  };
  errors = {
    forgot: undefined
  };
  submitted = false;
  mailSendSuccess = false;
  mailNotRegistered = false;

  /*@ngInject*/
  constructor(Auth, $state) {
    this.Auth = Auth;
    this.$state = $state;
  }

  submit(form) {
    this.submitted = true;

    this.mailSendSuccess = false;
    this.mailNotRegistered = false;

    if(form.$valid) {
      this.Auth.forgotPassword(this.user.email)
        .then(() => {
          this.mailSendSuccess = true;
        })
        .catch(err => {
          this.errors.login = err.message;
          this.mailNotRegistered = true;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/forgot-password/forgot-password.controller.js